import AssetStep from './AssetStep.vue';

export default AssetStep;
